import React from 'react';
import { PhotoAlbum, RenderPhoto } from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/dist/styles.css";
import Thumbnails from "yet-another-react-lightbox/dist/plugins/thumbnails";
import "yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css";
import { useState, useEffect } from "react"

const GalleryComponent = () => {

  const [originalData, setoriginalData] = useState([]);
  let [data, setData] = useState([]);
  let [slidesThumbnail, setSlidesThumbnail] = useState([]);
  let [slidesLightBox, setSlidesLightBox] = useState([]);
  const [index, setIndex] = React.useState(-1);
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const [marketData, setMarketData] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState('all');
  const [weekData, setWeekData] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState('all');

  const likeAndUnlikeFunction = val => {
    let url = '';
    let nid = '';

    // Function to create a new array with the updated item
    const updateArray = (originalArray, updatedItem) => {
      return originalArray.map((item) => item.nid === updatedItem.nid ? updatedItem : item);
    };

    // const updateFlaggedItem = (filteredItem) => {
    const updateFlaggedItem = (nid) => {

      let updateSelectedThumbnailItem = slidesThumbnail.filter(item => item.nid == nid);
      let updateSelectedLightboxItem = slidesLightBox.filter(item => item.nid == nid);

      let [newHrefThumbnail, likesThumbnail] = [
        updateSelectedThumbnailItem[0].flag.replace(/flag\/flag|flag\/unflag/, (match) => (match === 'flag/flag' ? 'flag/unflag' : 'flag/flag')),
        parseInt(updateSelectedThumbnailItem[0].likes),
      ];

      let [newHrefLightbox, likesLightbox] = [
        updateSelectedLightboxItem[0].flag.replace(/flag\/flag|flag\/unflag/, (match) => (match === 'flag/flag' ? 'flag/unflag' : 'flag/flag')),
        parseInt(updateSelectedLightboxItem[0].likes),
      ];

      if (updateSelectedThumbnailItem[0].flag.includes('flag/flag')) {
        likesThumbnail = likesThumbnail + 1;
        likesLightbox = likesLightbox + 1;
      } else {
        likesThumbnail = likesThumbnail - 1;
        likesLightbox = likesLightbox - 1;
      }

      updateSelectedThumbnailItem[0].flag = newHrefThumbnail;
      updateSelectedThumbnailItem[0].likes = likesThumbnail + '';
      updateSelectedLightboxItem[0].flag = newHrefLightbox;
      updateSelectedLightboxItem[0].likes = likesLightbox + '';

      /* Set updated link */
      setSlidesThumbnail(updateArray(slidesThumbnail, updateSelectedThumbnailItem));
      /* Set updated link */
      setSlidesLightBox(updateArray(slidesLightBox, updateSelectedLightboxItem));

      // return filteredItem[0];
    };

    const classNames = val.classList;
    classNames.forEach(className => {
      if (className.includes('flag-nid')) {
        nid = className.split('flag-nid-')[1];
      }
    });

    let flag = val.classList.contains('liked') ? 'unflag' : 'flag';

    url = window.location.href.replace('#ee-gallery', '') + `/flag/${flag}/likes/${nid}`;

    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onload = function() {
      if (xhr.status === 200) {
        if (flag == 'flag') {
          val.classList.remove('not-liked');
          val.classList.add('liked');
        } else {
          val.classList.remove('liked');
          val.classList.add('not-liked');
        }

        updateFlaggedItem(nid);

      } else {
        console.error('Like request failed:', xhr.statusText);
      }
    };

    xhr.onerror = function(error) {
      console.error('Like request error:', error);
    };
    xhr.send();
  }

  const fetchData = async (url) => {
    let dataArray = [];
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
      }
      if (response) {
        data = await response.json();
        dataArray = data.map((item) => {
          const nid = item.nid;
          const name = item.name;
          const market = item.market;
          const flag = item.flag;
          const likes = item.likes;
          const image_src = window.location.href.replace('#ee-gallery', '') + item.image_raw.split('src=\"/')[1].split('"')[0];
          const width = item.image_raw.split('width=\"')[1].split('"')[0];
          const height = item.image_raw.split('height=\"')[1].split('"')[0];
          const suburb = item.suburb;
          const winner = item.winner;
          const week = item.week;

          return {
            src: image_src,
            width,
            height,
            nid,
            name,
            market,
            flag,
            likes,
            suburb,
            winner,
            week,
          };
        });

        setoriginalData(dataArray);

        if (url.includes('thumbnail')) {
          setData(dataArray);
          setSlidesThumbnail(dataArray);
        } else {
          setData(dataArray);
          setSlidesLightBox(dataArray);
        }
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      return null;
    }
  };

  /* Render thumbnail */
  // let renderThumbnailPhotoWithLikes = ({
  //   photo,
  //   imageProps: { alt, style, ...restImageProps }
  // }) => (
  //   <div id={`node_${photo.nid}`} className={`gallery__thumbnail gallery__thumbnail__${photo.nid}`}>
  //     <img
  //       alt={alt}
  //       className='gallery__thumbnail__photo'
  //       {...restImageProps}
  //     />
  //     <div className={`gallery__thumbnail__bottom`}>
  //       {/* Like buttons */}
  //       <div className={`gallery__thumbnail__bottom__flag ${photo.flag.includes('unflag') ? 'liked' : 'not-liked'} flag-nid-${photo.nid}`} onClick={(e) => likeAndUnlikeFunction(e.target)}></div>
  //       <div className="like-container">
  //         <img className="flag-heart--active" src='themes/custom/basf2021/dist/app-drupal/assets/atomic/_patterns/01-atoms/svg/icons/ic-heart-filled.svg'/>
  //         <img className="flag-heart--default" src='themes/custom/basf2021/dist/app-drupal/assets/atomic/_patterns/01-atoms/svg/icons/ic-heart-outline.svg'/>
  //         <span className="likes-count">{photo.likes} votes</span>
  //       </div>

  //       <div className="gallery__thumbnail__bottom__name-market-container">
  //         {/* name */}
  //         <div className='gallery__thumbnail__bottom__name'>
  //           {photo.name}
  //         </div>
  //         {/* market */}
  //         <div className='gallery__thumbnail__bottom__market'>
  //           {photo.market}
  //         </div>
  //       </div>
  //     </div>

  //   </div>
  // );

  let renderThumbnailPhoto = ({
    photo,
    imageProps: { alt, style, ...restImageProps }
  }) => (
    <div id={`node_${photo.nid}`} className={`gallery__thumbnail gallery__thumbnail__${photo.nid} ${photo.winner == 'True' ? 'gallery__winner' : ''}`}>
      <img
        alt={alt}
        className='gallery__thumbnail__photo'
        {...restImageProps}
      />
      <div className={`gallery__thumbnail__bottom`}>
        <div className="gallery__thumbnail__bottom__name-market-container">
          {/* Conditional rendering of winner tag */}
          {photo.winner === 'True' && (
            <div className='gallery__thumbnail__winner_tag'>
              {`${photo.week} Winner`}
            </div>
          )}

          {/* name */}
          <div className='gallery__thumbnail__bottom__name'>
            {photo.name}
          </div>
          {/* market */}
          <div className='gallery__thumbnail__bottom__market'>
          {photo.suburb}, {photo.market.replace('&#039;', "'")}
          </div>
        </div>
      </div>

    </div>
  );

  // const CustomLightboxSlideWithLike = ({ photo }) => {
  //   // Destructure relevant data from the photo object
  //   const { nid, src, name, market, flag, likes } = photo;

  //   return (
  //     <div className="custom-lightbox-slide">
  //       <img className="custom-lightbox-slide__image" src={src} />

  //       <div className="custom-lightbox-slide__bottom">
  //         <div className="custom-lightbox-slide__bottom__container">
  //           {/* Like buttons */}
  //           <div className={`custom-lightbox-slide__bottom__flag gallery__thumbnail__bottom__flag ${flag.includes('unflag') ? 'liked' : 'not-liked'} flag-nid-${nid}`} onClick={(e) => likeAndUnlikeFunction(e.target)}></div>
  //           <div className="like-container">
  //             <img className="flag-heart--active" src='themes/custom/basf2021/dist/app-drupal/assets/atomic/_patterns/01-atoms/svg/icons/ic-heart-filled.svg'/>
  //             <img className="flag-heart--default" src='themes/custom/basf2021/dist/app-drupal/assets/atomic/_patterns/01-atoms/svg/icons/ic-heart-outline.svg'/>
  //             <span className="likes-count">{photo.likes} votes</span>
  //           </div>

  //           <div className="gallery__thumbnail__bottom__name-market-container">
  //             {/* name */}
  //             <div className="custom-lightbox-slide__title gallery__thumbnail__bottom__name">{name}</div>
  //             {/* market */}
  //             <div className="custom-lightbox-slide__market gallery__thumbnail__bottom__market">{market}</div>
  //           </div>

  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const CustomLightboxSlide = ({ photo }) => {
    // Destructure relevant data from the photo object
    const { nid, src, name, market, flag, likes, week, suburb, winner } = photo;

    return (

      <div className={`custom-lightbox-slide ${winner == 'True' ? 'gallery__winner' : ''}`}>
        <img className="custom-lightbox-slide__image" src={src} />

        <div className="custom-lightbox-slide__bottom">
          <div className="custom-lightbox-slide__bottom__container">
            <div className="gallery__thumbnail__bottom__name-market-container">
              {/* Conditional rendering of winner tag */}
              {winner === 'True' && (
                <div className='gallery__thumbnail__winner_tag'>
                  {`${week} Winner`}
                </div>
              )}

              {/* name */}
              <div className="custom-lightbox-slide__title gallery__thumbnail__bottom__name">{name}</div>
              {/* market */}
              <div className="custom-lightbox-slide__market gallery__thumbnail__bottom__market">{suburb}, {market.replace('&#039;', "'")}</div>
            </div>

          </div>
        </div>
      </div>
    );
  };

  /* init Market filter */
  const selectMarketFilter = document.getElementById("marketFilter");
  const initMarketFilter = async () => {

    const response = await fetch(window.location.href.replace('#ee-gallery', '') + '/market');
    if (response) {
      const dataArray = await response.json();
      setMarketData(dataArray);
    }
  };

  /* Market filter listener */
  if (selectMarketFilter != null) {
    selectMarketFilter.addEventListener("change", function() {
      /* Grab market value */
      const selectedMarket = selectMarketFilter.value;
      setSelectedMarket(selectedMarket);
    });
  }

  /* Market filter */
  const filterDataByMarket = market => {
    let dataArray = originalData.filter(item => item.market === market);
    dataArray.filter(item => item.market == market);

    setData([]); // Clear existing data
    setSlidesThumbnail([]); // Clear existing data
    setSlidesLightBox([]); // Clear existing data

    setData(dataArray);
    setSlidesThumbnail(dataArray);
    setSlidesLightBox(dataArray);
  }

  /* init Week filter */
  const selectWeekFilter = document.getElementById("weekFilter");
  const initWeekFilter = async () => {

    const response = await fetch(window.location.href.replace('#ee-gallery', '') + '/week');
    if (response) {
      const dataArray = await response.json();
      setWeekData(dataArray);
    }
  };

  /* Week filter listener */
  if (selectWeekFilter != null) {
    selectWeekFilter.addEventListener("change", function() {
      /* Grab week value */
      const selectedWeek = selectWeekFilter.value;
      setSelectedWeek(selectedWeek);
    });
  }

  /* Week filter */
  const filterDataByWeek = week => {
    let dataArray = originalData.filter(item => item.week === week);
    dataArray.filter(item => item.week == week);

    setData([]); // Clear existing data
    setSlidesThumbnail([]); // Clear existing data
    setSlidesLightBox([]); // Clear existing data

    setData(dataArray);
    setSlidesThumbnail(dataArray);
    setSlidesLightBox(dataArray);
  }


  useEffect(() => {
    initMarketFilter();
    initWeekFilter();

    if (selectedMarket !== 'all' && selectedMarket !== '') {
      filterDataByMarket(selectedMarket);
    } else if (selectedWeek !== 'all' && selectedWeek !== '') {
      filterDataByWeek(selectedWeek);
    } else {
      if (!hasFetchedData) {
        fetchData(window.location.href.replace('#ee-gallery', '') + '/submissions-thumbnail');
        fetchData(window.location.href.replace('#ee-gallery', '') + '/submissions-lightbox');
        setHasFetchedData(true);
      } else {
        setData(originalData);
        setSlidesThumbnail(originalData);
        setSlidesLightBox(originalData);
      }
    }
  }, [selectedMarket, selectedWeek, originalData]); // Empty dependency array ensures effect runs only on mount

  return (
    <>
      <div className='gallery__header'>
        <div className='gallery__title'>Received entries</div>
        {/* <select id="marketFilter">
          <option value="">Show all locations</option>
          {marketData.map((item) => (
            <option key={item.name} value={item.name} defaultValue={selectedMarket === item.name}>
              {item.name}
            </option>
          ))}
        </select> */}
        <select id="weekFilter">
          <option value="">Show all weeks</option>
          {weekData.map((item) => (
            <option key={item.name} value={item.name} defaultValue={selectedWeek === item.name}>
              {item.name}
            </option>
          ))}
        </select>
      </div>
      {/* {slidesThumbnail ? ( */}
        <>
          <PhotoAlbum
            layout="masonry"
            photos={slidesThumbnail}
            renderPhoto={renderThumbnailPhoto}
            columns={(containerWidth) => {
              if (containerWidth < 400) return 1;
              if (containerWidth < 1024) return 3;
              return 4;
            }}
            onClick={({ index: current }) => setIndex(current)}
          />
          <Lightbox
            index={index}
            on={{ view: ({ index: currentIndex }) => setIndex(currentIndex) }}
            slides={slidesLightBox}
            open={index >= 0}
            render={{
              slide: ({ slide }) => (
                <CustomLightboxSlide photo={slide} /> // Pass photo data to the custom component
              ),
            }}
            close={() => setIndex(-1)}
            plugins={[Thumbnails]}
          />
        </>
      {/* ) : (
        <p>List is loading kindly wait ..</p>
      )} */}
    </>
  );
};

export default GalleryComponent;